import React, { useState } from "react";
import LobbyScreen from "./LobbyScreen";
import GameScreen from "./GameScreen";

function App() {
  const [session, setSession] = useState(null);
  // session = { gameId, playerId, playerName, words }

  if (!session) {
    return <LobbyScreen onJoined={setSession} />;
  }

  return <GameScreen session={session} />;
}

export default App;
